import React, {useEffect} from 'react'
import styled from 'styled-components'
import { useObserver } from 'mobx-react'
import { Alert, Spinner } from 'react-bootstrap'
import useStores from '../../../stores/useStore'
import StoreReceiptSubheader from '../../../components/LocalReceipts/StoreReceipts/StoreReceiptSubheader'
import StoreReceiptSidebar from '../../../components/LocalReceipts/StoreReceipts/StoreReceiptSidebar'
import StoreReceiptContentArea from '../../../components/LocalReceipts/StoreReceipts/StoreReceiptContentArea'
import { StyledGoodReceiptsContainer } from '../../../components/LocalReceipts/Form/formHelper'
import { useTranslation } from 'react-i18next'
import { ContentArea } from '../../../components/Page/logix2020/ContentArea'
import { TestSidebarRight } from '../../../components/Page/logix2020/TestSidebarRight'
import BigFooter from '../../../components/Footer/BigFooter'
import { FlexWrapper } from '../../../components/Page/logix2020/FlexWrapper'
import LocalReceiptDataProvider, { useLocalReceiptDataState } from '../../../stores/LocalReceiptDataProvider'
import { useParams } from 'react-router-dom'

const StyledContentArea = styled(ContentArea)`
   padding: 20px 40px 20px 36px;
   @media (max-width: 1080px) {
    padding: 20px;
    min-height: calc(100vh - 488px);//header+navbar+sidebar=488px
   }
   .added-row {
    label {
      display: block;
    }
  }
`
const StoreGoodsReceiptPageContent = () => {
    const { receiptId } = useParams()
    const { loadReceiptData } = useLocalReceiptDataState()
    
    useEffect(() => {
      const init = async () => {
        loadReceiptData(receiptId, 'store')
      }
      init()
    }, [receiptId, loadReceiptData])
  
    return (
        <>
        <StoreReceiptSubheader />
        <FlexWrapper>
          <StyledContentArea>
            <StoreReceiptContentArea />
          </StyledContentArea>
          <TestSidebarRight>
            <StoreReceiptSidebar />
          </TestSidebarRight>
        </FlexWrapper>
        <BigFooter />
      </>
    )
  }
  
  const StoreGoodsReceiptPage = () => {
    const { uiStore } = useStores()
    const { t } = useTranslation()
    const dashboardLoaded = useObserver(() => !!uiStore.dashboard)
  
  
    return useObserver(() => (
      <LocalReceiptDataProvider>
        <StyledGoodReceiptsContainer>
          {!dashboardLoaded || !uiStore.isLocalStorageAdmin
            ? (
              <FlexWrapper>
                <StyledContentArea>
                  {dashboardLoaded
                    ? <Alert variant="danger">{t('goodsReceiptPage:storeReceiptAlert')}</Alert>
                    : <div className="d-flex align-items-center justify-content-center">< Spinner animation='border' variant='primary' /></div >
                  }
                </StyledContentArea>
                <TestSidebarRight>
                </TestSidebarRight>
              </FlexWrapper>)
            :
            <StoreGoodsReceiptPageContent />
          }
          <BigFooter />
        </StyledGoodReceiptsContainer>
      </LocalReceiptDataProvider>
    ))
  }
  
  export default StoreGoodsReceiptPage
  